export const incrementTimeByElapsedSeconds = (
  initialTime: string,
  elapsedSeconds: number
): { value: string; title: string } => {
  let hasDays = false;

  const [day, time, miliseconds] = initialTime.split('.');

  // in case some of this is false, time has come without day number and we are adding default 0 value
  if (day && time && miliseconds) {
    hasDays = true;
  }

  // Parse the initial time
  const [dayPart, timePart] = hasDays ? initialTime.split('.') : `0.${initialTime}`.split('.');
  const days = parseInt(dayPart || '0', 10);
  const [hours, minutes, seconds] = timePart.split(':').map(Number);

  // Convert the initial time to total seconds
  let totalSeconds = days * 86400 + hours * 3600 + minutes * 60 + seconds;

  // Add the elapsed time
  totalSeconds += elapsedSeconds;

  // Convert total seconds back to days, hours, minutes, and seconds
  const newDays = Math.floor(totalSeconds / 86400);
  totalSeconds %= 86400;

  const newHours = Math.floor(totalSeconds / 3600);
  totalSeconds %= 3600;

  const newMinutes = Math.floor(totalSeconds / 60);
  const newSeconds = totalSeconds % 60;

  // we are not showing days on UI, so have to add these days to total hours
  const daysToHours = days * 24;

  return {
    value: `${String(newHours + daysToHours).padStart(2, '0')}:${String(newMinutes).padStart(2, '0')}`,
    title: `${newDays}.${String(newHours).padStart(2, '0')}:${String(newMinutes).padStart(2, '0')}:${String(newSeconds).padStart(2, '0')}`,
  };
};
